import { Address } from 'models';

export function addressToString(address: Address) {
    return `${address.street ? address.street : ''} ${address.city} ${address.state} ${address.zip_code}`;
}
